import React, { FC, ChangeEvent, MouseEventHandler, ReactNode } from 'react';

import style from './input.style.module.scss';

type Props = {
  id: string;
  type: 'text' | 'password';
  placeholder: string;
  name: string;
  label: string;
  onChange: (e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => void;
  onBlur?: (e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => void;
  value: string;
  error: string;
  disabled?: boolean;
  className?: string;
  onClick?: MouseEventHandler<HTMLDivElement>;
  icon?: ReactNode;
  isSearch?: boolean;
};

const KlicInputAutocomplete: FC<Props> = ({
  id,
  placeholder,
  name,
  onChange,
  onBlur,
  value,
  error,
  className,
  onClick,
  icon,
  isSearch = false,
}) => {
  return (
    <div
      className={`${style['input-container']} ${
        error ? style['error'] : ''
      } ${className}`}
      onClick={(event) => onClick && onClick(event)}
    >
      <input
        id={id}
        autoComplete="on"
        onChange={onChange}
        onBlur={onBlur}
        name={name}
        type={'text'}
        value={value}
      />

      {icon && isSearch && <div className={style['search-icon']}>{icon}</div>}
      {icon && !isSearch && <>{icon}</>}
      {error && <div className={style['error-message']}>{error}</div>}
    </div>
  );
};

export default KlicInputAutocomplete;
